import { render, staticRenderFns } from "./edit-commission.vue?vue&type=template&id=68d151f3&scoped=true"
import script from "./edit-commission.vue?vue&type=script&lang=js"
export * from "./edit-commission.vue?vue&type=script&lang=js"
import style0 from "./edit-commission.vue?vue&type=style&index=0&id=68d151f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d151f3",
  null
  
)

export default component.exports